import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/product-mapping')({
  beforeLoad: ({ location }) => {
    if (
      location.pathname === '/product-mapping' ||
      location.pathname === '/product-mapping/'
    ) {
      throw redirect({ to: '/product-mapping/active', search: {} } as never);
    }
  },
  component: ProductMappingShell,
});

function ProductMappingShell() {
  return (
    <div className='flex flex-col flex-1 min-h-0 overflow-hidden'>
      <Outlet />
    </div>
  );
}
